import { useEffect, useRef, useState } from "react";

export function useHover<E extends HTMLElement = HTMLElement>(): [
  React.RefObject<E | null>,
  boolean,
] {
  const ref = useRef<E | null>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleMouseMove = (event: any) => {
      if (!ref.current) {
        return;
      }
      const rect = ref.current.getBoundingClientRect();
      const cursorX = event.clientX;
      const cursorY = event.clientY;
      if (
        cursorX >= rect.left &&
        cursorX <= rect.right &&
        cursorY >= rect.top &&
        cursorY <= rect.bottom
      ) {
        setIsHovered(true);
      } else {
        setIsHovered(false);
      }
    };
    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [setIsHovered]);

  return [ref, isHovered];
}
